<ng-container *transloco="let t;">
<form (submit)="onSubmit()" novalidate>

    <div class="p-grid">
        <div class="p-col-6">
            <h2>{{ t('common.labels.basedata') }}</h2>
        </div>
        <div class="p-col-6 p-text-right">
          <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
        </div>
    </div>

    <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')"></app-form-control>
          <div class="p-grid">
            <div class="p-col-6"><app-form-control [cid]="'onsite'" [control]="form.get('onsite')" [type]="'checkbox'" [label]="t('common.labels.onsite')"></app-form-control></div>
            <div class="p-col-6"><app-form-control [cid]="'virtual'" [control]="form.get('virtual')" [type]="'checkbox'" [label]="t('common.labels.virtual')"></app-form-control></div>
          </div>
        </div>
        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'language'" [control]="form.get('language')" [type]="'select'" [options]="languages" [label]="t('common.labels.language')"></app-form-control>
          <app-form-control [cid]="'ratingtype'" [control]="form.get('ratingtype')" [type]="'select'" [options]="ratingtypes" [optionLabel]="'name.' + transloco.getActiveLang().toUpperCase()" [label]="t('common.labels.ratingtype')"></app-form-control>
          <app-form-control [cid]="'type'" [control]="form.get('type')" [type]="'select'" [options]="types" [label]="t('common.labels.type')"></app-form-control>
        </div>
      </div>

      <hr>

      <h2>{{ t('common.labels.settings') }}</h2>
      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'documents_visible_observer'" [control]="form.get('documents_visible_observer')" [type]="'checkbox'" [label]="t('ac_basedata.documents_visible_observer')"></app-form-control>
        </div>
      </div>

  </form>
</ng-container>
